<script setup>
import { useModalStore } from '@/store/modal'
import { useAuthStore } from '@/store/auth'
import { Sparkle } from 'lucide-vue-next'
import {Button} from '@/components/ui/button'
const modal = useModalStore()
const authStore = useAuthStore()
const props = modal.modalProps

</script>

<template>
  <div class="bg-white p-8 rounded-[16px] shadow-lg w-[448px] flex flex-col items-center">

    <div class="flex items-center gap-2 bg-[#EAECEF] py-2 px-4 h-[48px] rounded-[10px] text-white text-[15px] font-semibold mb-6">
      <Sparkle class="h-5 w-5" fill="grey" stroke="transparent"/>
    </div>

    <h2 class="text-[28px] font-semibold text-[#111111] mb-3 text-center">
      Недостаточно Токенов<br/>
    </h2>
    
    <p class="text-[15px] text-[#111111] mb-6 text-center">
      К сожалению, у вас закончились токены на скрининг. Свяжитесь с менеджером для пополнения баланса.
    </p>

    <div class="flex gap-4 w-full">
      <Button as-child class="rounded-[12px]">
        <a class="w-full h-[56px] bg-[#60D669] text-white font-semibold py-4 px-6 text-[15px] hover:bg-[#4FB659] transition-colors" 
          href="https://wa.me/77011814161" target="_blank"><img src="@/assets/icons/whatsapp.svg" alt="whatsapp" class="inline-block" />Связаться в WhatsApp</a>
      </Button>
    </div>
  </div>
</template>

<style scoped>
</style>
